class ConfigParameters {
  constructor(params) {
    this.addressExtraInfoFields = params.addressExtraInfoFields;
    this.countryDocuments = params.countryDocuments;
    this.minimumFinancingPercentage = params.minimumFinancingPercentage;
    this.intraSearchFilters = params.intraSearchFilters;
    this.paymentMethods = params.paymentMethods;
    this.contactReasons = params.contactReasons;
    this.installationDate = params.installationDate;
    this.disableSale = params.disableSale;
  }
}

export { ConfigParameters };



// WEBPACK FOOTER //
// ./src/models/ConfigParameters.js